import { useEffect, useState, useMemo, useCallback } from "react";
import Web3 from "web3";
import { chinaContract } from '../../../utils/contractHelpers';

export function useRoundData(project) {

    // memoize web3 to avoid re-renders
    const web3 = useMemo(() => {
        if (!project?.rpc) return null;
        return new Web3(project.rpc);
    }, [project?.rpc]);

    const [roundData, setRoundData] = useState({
        round: null,
        price: null,
        startTime: null,
        endTime: null
    });

    const [loading, setLoading] = useState(true);

    // fetch logic
    const fetchRoundData = useCallback(async () => {
        if (!project?.contractAddress || !web3 || project.saleType !== "live") return;

        try {
            setLoading(true);

            const contract = chinaContract(project.contractAddress, web3);
            const currentRound = await contract.methods.getRoundCount().call();

            if (!currentRound) return;

            const roundDetails = await contract.methods.rounds(currentRound).call();
            const priceInEth = web3.utils.fromWei(roundDetails.price, "ether");

            setRoundData({
                round: currentRound,
                price: priceInEth,
                startTime: Number(roundDetails.startTime) * 1000,
                endTime: Number(roundDetails.endTime) * 1000
            });
        } catch (err) {
            console.error("Error fetching live project data:", err);
        } finally {
            setLoading(false);
        }
    }, [project?.contractAddress, project?.saleType, web3]);

    useEffect(() => {
        fetchRoundData();
    }, [fetchRoundData]);

    return {
        roundData,
        loading,
        refresh: fetchRoundData
    };
}
